import { Select, SelectProps } from "@mantine/core"
import { ResourceTypeCategory } from "../../../../@client/Theasoft_DataClasses_Dispo"
import { useTranslation } from "react-i18next"
import { useGetResourceTypeCategoriesSuspense } from "@/orval/gen"

interface Props extends Omit<SelectProps, "value" | "onChange"> {
  value: ResourceTypeCategory
  onChange: (value: ResourceTypeCategory) => void
}

export function ResourceTypeCategorySelect({
  value,
  onChange,
  ...props
}: Props) {
  const { t } = useTranslation("app_server")
  const { data: categories } = useGetResourceTypeCategoriesSuspense()
  const data = categories.map((v) => ({
    value: v,
    label: t(`ResourceTypeCategory_${v}`),
  }))
  return (
    <Select
      data={data}
      value={value}
      onChange={(v) => v && onChange(v as ResourceTypeCategory)}
      {...props}
    />
  )
}
